<template>
  <header class="header">
    <div class="header--content">
      <h1>Sigorta Sözlüğü</h1>
      <p class="mt-5">
        Sigorta Basitçe Açıkladı. Sigorta Hakkında Bilmek İstediğiniz Her Şey.
      </p>
      <p class="mt-5">Temsilcinizin Size Ne Sunduğunu Tam Olarak Anlayın!</p>
        <v-col cols="10" sm="7" md="5" class="pa-0 d-relative">
        <!-- SEARCH INPUT -->

        <v-text-field
          v-model="searchText"
          :items="filteredData"
          type="search"
          ref="search"
          placeholder="poliçe nedir?"
          @focus="onfocus"
          @change="search"
          rounded
          solo
          single-line
          hide-details
        >
          <template #append>
            <v-btn color="success" solo rounded @click="search">
              Ara
            </v-btn>
          </template>
        </v-text-field>

        <!-- SEARCH RESULTS LIST -->

        <v-card
        class="mx-auto mt-1"
        style="left:0; right:0; top:0; overflow:auto; z-index:5"
        max-width="600"
        max-height="100"
        outlined
        elevation="0"
        v-if="filteredData.length > 0"
      >
        <v-list dense v-if="filteredData.length > 0">
          <v-list-item v-for="(item, index) in filteredData" :key="index">
            <v-list-item-content>
              <v-list-item-title>
                <router-link :to="`sigorta-sozlugu/${item.screenId}`">
                  {{ item.keyWord }}
                </router-link>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
      </v-col>

    </div>
  </header>
</template>

<script>
import axios from "axios"
export default {
  props: ["BASE_URL"],
  data() {
    return {
      data: [],
      filteredData: [],
      searchText: ""
    }
  },
  methods: {
    onfocus() {
      this.getData()
      console.log("sözlük list getirildi")
    },

    // sözlük verilerini çek
    getData() {
      axios.get(this.BASE_URL + "/adm/dictionary/list").then(response => {
        this.data = response.data
        console.log("Searched dictionary data:", this.data)
      })
    },
    search() {
      this.filteredData = []
      // if input is not empty
      if (this.searchText.length > 0) {
        this.data.forEach(item => {
          if (
            item.keyWord.toLowerCase().includes(this.searchText.toLowerCase())
          ) {
            console.log("Aranan kelime:", this.searchText)
            this.filteredData.push(item)
            console.log("FilteredData:", this.filteredData)
          }
        })
        // if no result found
        if (this.filteredData.length === 0) {
          alert("Sonuç bulunamadı")
          this.searchText = ""
          this.$refs.search.focus()
        }
      }
    }
  }
}
</script>
